<template>
    <div class="column is-12">
        <div :class="classes" @click.capture="selecionar">
            <div v-if="mostraAccessionNumber">
                <div v-if="guiaId" class="column is-1">
                    <small>Guia:</small>
                    <br />
                    <router-link class="is-block" :to="{ name: 'guia', params: { id: guiaId }}" >
                        {{ guiaId  }}
                    </router-link>  
                </div>  
                <div v-else class="column is-1">
                    <small>AccessionNumber:</small>
                    <br />
                    <b>{{ estudo.accessionNumber }}</b>
                </div>
            </div>
            <div class="column is-1 has-text-centered">
                <img :src="imageSrc()" style="max-height:50px;">
            </div>
            <div class="column is-5">
                <b>{{this.estudo.studyDescription}}</b>
                <br />
                <small>{{this.estudo.modsInStudy}}</small>
            </div> 
            <div class="column has-text-centered">
                <p class="is-size-7">{{ estudo.studyDatetime | moment('DD/MM/YY') }}</p>
                <p class="is-size-7">{{ estudo.studyDatetime | moment('HH:mm') }}</p>
            </div>
            <div class="column">
                <b-tag v-for="(item, index) in this.estudo.exames" v-bind:key="index"
                       :type="exameStatus(item)" :title="exameStatusTitle(item)">
                    {{ item.apelido }}
                </b-tag>
            </div>            
            <div class="column">
                <b-button v-if="this.estudo.viewers != null && this.estudo.viewers.length > 0"
                          type="is-primary is-pulled-right" size="is-medium" icon-left="eye" 
                          tag="a" :href="this.estudo.viewers[0].url" target="_blank"
                          title="Visualizar imagens"></b-button>
                <b-button type="is-pulled-right" size="is-medium" icon-left="file-document-edit-outline" 
                          tag="router-link" :to="{ name: 'estudolaudo', params: { id: this.estudo.id }}"
                          title="Laudar estudo"></b-button>
                <b-tag>{{this.estudo.numSeries}} séries</b-tag>
                <br />
                <b-tag type="is-info">{{this.estudo.numInstances}} imagens</b-tag>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        props: {
            estudo: Object,
            index: Number,
            selecionado: Boolean,
            mostraAccessionNumber: Boolean
        },
        data() {
            return {
                classes: this.defineClasses()
            }
        },
        watch: {
            selecionado: function() {
                this.classes = this.defineClasses()
            }
        },
        computed: {
            ...mapState([
                'config',
            ]),                    
            guiaId() {
                return this.estudo.exames?.length > 0
                    ? this.estudo.exames[0].guiaId
                    : null
            }
        },
        methods: {
            defineClasses() {
                return "columns is-multiline guiaEstudo" +
                    (this.selecionado ? " guiaEstudoSelecionado" : "")
            },
            selecionar() {
                if (this.estudo.id != 0) {
                    this.$emit('selecionarEstudo', this.estudo)
                }
            },
            imageSrc() {
                return "data:image/png;base64, " + this.estudo.thumbnail
            },
            exameStatus(item) {
                return item.cancelado
                    ? "is-danger"
                    : item.resultadoAssinado
                        ? "is-success"
                        : item.resultadoDigitado
                            ? "is-info"
                            : ""
            },
            exameStatusTitle(item) {
                return item.cancelado
                    ? this.$t('AMOSTRA.EXAMECANCELADO')
                    : item.resultadoAssinado
                        ? this.$t('AMOSTRA.EXAMEASSINADO')
                        : item.resultadoDigitado
                            ? this.$t('AMOSTRA.EXAMEDIGITADO')
                            : ""
            },
        }
    }
</script>